<template>
    <div class="d-flex">
        <div class="pa-3" style="background-color: white;">
            <pre>{{ textContent }}</pre>
        </div>
        <div class="flex-1 pa-3" style="background: white; border-left: 1px solid red;">
            <div v-html="htmlContent"></div>
        </div>
    </div>
</template>

<script>
import Printable from '@/utilities/Printable'

export default {
    created() {
        const pr = new Printable()

        pr.l('S', 'spaceBetween:', 'right')
        pr.l('B', 'spaceOrBreak:', 'right')
        pr.l('D', 'divider', { delimiter: '-', align: 'C' })
        pr.l('D', 'divider', { delimiter: '=', align: 'R' })
        pr.l('D', 'signature', { delimiter: '_', align: 'L' })
        pr.l('L', 'leftLine', { align: 'L' })
        pr.l('L', 'centerLine', { align: 'C' })
        pr.l('L', 'rightLine', { align: 'R' })
        pr.l('D', '', { delimiter: '-' })
        pr.l('L', 'rightLine that overflows the limit', { align: 'R' })
        pr.l('D', '', { delimiter: '-' })
        pr.l('L', 'rightLinerightLinerightLinerightLinerightLine that overflows the limit', { align: 'R' })
        pr.l('D', '', { delimiter: '-' })
        pr.l('L', 'centerLine that overflows the limit', { align: 'C' })
        pr.l('D', '', { delimiter: '-' })
        pr.table({
            colNumber: 4,
            heading: true,
            text: {
                colWidths: [null, 8, 8, 8],
            },
            html: {
                colWidths: [25, 25, 25, 25],
                style: { background: 'white' },
            }
        })
        pr.tl(
            { content: 'Pauliner', align: 'L' },
            { content: '2.02', align: 'R' },
            { content: '1.00', align: 'R' },
            { content: '12.12', align: 'R' },
            { content: '   Popust: 20%', align: 'L', colSpan: 3 },
            { content: '12.11', align: 'R' },
            { content: 'Heineken', align: 'L' },
            { content: '4.10', align: 'R' },
            { content: '2.00', align: 'R' },
            { content: '24.20', align: 'R' },
            { content: 'divider' },
            { content: 'Heineken', align: 'L' },
            { content: '4.10', align: 'R' },
            { content: '2.00', align: 'R' },
            { content: '24.20', align: 'R' },
            { content: 'Heineken', align: 'L', style: { background: 'lightgrey' } },
            { content: '4.10', align: 'R', style: { background: 'lightgrey' } },
            { content: '2.00', align: 'R', style: { background: 'lightgrey' } },
            { content: '24.20', align: 'R', style: { background: 'lightgrey' } },
            { content: 'Heineken', align: 'L' },
            { content: '4.10', align: 'R' },
            { content: '2.00', align: 'R' },
            { content: '24.20', align: 'R' },
            { content: 'Heineken', align: 'L' },
            { content: '4.10', align: 'R' },
            { content: '2.00', align: 'R' },
            { content: '24.20', align: 'R' },
            { content: 'Heineken', align: 'L' },
            { content: '4.10', align: 'R' },
            { content: '2.00', align: 'R' },
            { content: '24.20', align: 'R' },
            { content: 'divider' },
            { content: 'Heineken', align: 'L' },
            { content: '4.10', align: 'R' },
            { content: '2.00', align: 'R' },
            { content: '24.20', align: 'R' },
            { content: 'divider' },
        )
        pr.l('D', '', { delimiter: '=', align: 'L' })

        this.printable = pr
    },

    data() {
        return {
            printable: null
        };
    },

    computed: {
        textContent() {
            return this.printable.toText(48).join('\n')
        },

        htmlContent() {
            return this.printable.toHtml().join('')
        },
    },

    methods: {

    }
};
</script>

<style lang="scss" scoped>
.test {
    text-align: center;

    .container {
        max-width: 400px;
    }
}
</style>
